module.exports = __webpack_public_path__ + "img/service-introduction-4.2b39a3bc.png";